import { render } from "./OpenQuests.vue?vue&type=template&id=1fe6aafa"
import script from "./OpenQuests.vue?vue&type=script&lang=js"
export * from "./OpenQuests.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/questBook/OpenQuests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fe6aafa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fe6aafa', __exports__)) {
    api.reload('1fe6aafa', __exports__)
  }
  
  module.hot.accept("./OpenQuests.vue?vue&type=template&id=1fe6aafa", () => {
    api.rerender('1fe6aafa', render)
  })

}


export default __exports__